import React from 'react';
import styles from './MealPlanPopup.module.css';

/** Rótulos das colunas dos itens, uma vez por refeição (só quando há itens). */
const MealItemsHeader = () => (
  <div className={`${styles.itemGrid} ${styles.itemsHeader}`} aria-hidden="true">
    <span>Alimento</span>
    <span className={styles.itemsHeaderQty}>Qtd.</span>
    <span>Unidade</span>
    <span />
  </div>
);

export default MealItemsHeader;
